export { default } from './Recommendations';
